<template>
  <div class="homefooterad_main">
    <div class="homefooterad_top">
      <span><span>影像中山&nbsp;&nbsp;</span><span>·</span><span>&nbsp;&nbsp;记录美好</span></span>
    </div>
    <div class="homefooterad_bottom">
      <div class="homefooterad_bottom_main">
        <div class="homefooterad_bottom_logo">
          <!-- <img src="m4blogo.photo1" /> -->
          <img src="../../static/images/icon/blogo.png" />
        </div>
        <div class="footer_group" v-for="(group,index) in groups" :key="index">
          <footer-group :obj="group"></footer-group>
        </div>
        <div class="footer_group2">
          <div class="sns">
            <div class="snstop">社交媒体</div>
            <div class="snsbot">
              <div class="snsbot1">
                <div v-if="lefttop" class="snsitem" @mouseover="lefttopOver" @mouseout="lefttopOut">
                  <div class="snsitemdesc">中山日报微信</div>
                  <img src="../../static/images/icon/lefttop.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="lefttopOver" @mouseout="lefttopOut">
                  <div style="text-align:center;margin-bottom:10px">中山日报微信</div>
                  <img src="../../static/images/icon/lefttop.jpg">
                </div>
                <div v-if="righttop" class="snsitem" @mouseover="righttopOver" @mouseout="righttopOut">
                  <div class="snsitemdesc">中山画刊微信</div>
                  <img src="../../static/images/icon/righttop.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="righttopOver" @mouseout="righttopOut">
                  <div style="text-align:center;margin-bottom:10px">中山画刊微信</div>
                  <img src="../../static/images/icon/righttop.jpg">
                </div>
              </div>
              <div class="snsbot2">
                <div v-if="leftbot" class="snsitem" @mouseover="leftbotOver" @mouseout="leftbotOut">
                  <div class="snsitemdesc">中山日报APP</div>
                  <img src="../../static/images/icon/leftbot.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="leftbotOver" @mouseout="leftbotOut">
                  <div style="text-align:center;margin-bottom:10px">中山日报APP</div>
                  <img src="../../static/images/icon/leftbot.jpg">
                </div>
                <div v-if="rightbot" class="snsitem" @mouseover="rightbotOver" @mouseout="rightbotOut">
                  <div class="snsitemdesc">中山网</div>
                  <img src="../../static/images/icon/rightbot.jpg">
                </div>
                <div v-else class="snsitemhover" @mouseover="rightbotOver" @mouseout="rightbotOut">
                  <div style="text-align:center;margin-bottom:10px">中山网</div>
                  <img src="../../static/images/icon/rightbot.jpg">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="homefooterad_bottom_copyrite">
        <div>
          <span style="cursor:pointer" @click="webtermsClick">网站条款</span>
          <span class="line">&nbsp;|&nbsp;</span>
          <span @click="copyrightClick" style="cursor:pointer">版权声明</span>
          <span class="line">&nbsp;|&nbsp;</span> 网址：zsphoto.zsnews.cn
          <span class="line">&nbsp;|&nbsp;</span>www.zsphoto.cn
          <span class="line">&nbsp;|&nbsp;</span>业务电话：0760-88333611
        </div>
        <div>
          粤ICP备05077135号-7
          <span class="line">&nbsp;|&nbsp;</span>粤公网安备 44200002443192号
          <span class="line">&nbsp;|&nbsp;</span>增值电信业务经营许可证：粤B2-20160575
          <span class="line">&nbsp;|&nbsp;</span> 违法和不良信息举报电话：88881025&nbsp;&nbsp; 88881049</div>
        <div>
          <span>Copyright@2018
            <span>&nbsp;&nbsp;&nbsp;</span>
            中山日报报业集团
            <span>&nbsp;&nbsp;&nbsp;</span>
            版权所有
            <span>&nbsp;&nbsp;&nbsp;</span>
            中山日报报业集团旗下产品
            <span>&nbsp;&nbsp;&nbsp;</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import footerGroup from "./footerGroup";
import { getModuleInfo } from "./../services/api.js";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      groups: [
        {
          title: "中山影像",
          list: [
            { text: "关于我们", url: "/aboutus" },
            { text: "联系我们", url: "/chatus" }
          ]
        },
        {
          title: "帮助中心",
          list: [
            { text: "购图指南", url: "/shopread" },
            { text: "供图指南", url: "/sellread" },
            // { text: "下载问题", url: "/quesanswer" }
          ]
        },
        {
          title: "授权条款",
          list: [
            { text: "使用许可协议", url: "" },
            { text: "销售代理协议", url: "/salesagency" }
          ]
        }
      ],
      m4blogo: {},
      moduleIds: [14],
      lefttop: true,
      righttop: true,
      leftbot: true,
      rightbot: true
    };
  },
  components: {
    footerGroup
  },
  mounted() {
    this.getMInfo();
  },
  computed: {
    ...mapGetters(["example", "webID"])
  },
  methods: {
    webtermsClick() {
      let routeData = this.$router.resolve({
        path: "/webterms"
      });
      window.open(routeData.href, "_blank");
    },
    copyrightClick() {
      let routeData = this.$router.resolve({
        path: "/copyright"
      });
      window.open(routeData.href, "_blank");
    },
    lefttopOver() {
      this.lefttop = !this.lefttop;
    },
    lefttopOut() {
      this.lefttop = !this.lefttop;
    },
    righttopOver() {
      this.righttop = !this.righttop;
    },
    righttopOut() {
      this.righttop = !this.righttop;
    },
    leftbotOver() {
      this.leftbot = !this.leftbot;
    },
    leftbotOut() {
      this.leftbot = !this.leftbot;
    },
    rightbotOver() {
      this.rightbot = !this.rightbot;
    },
    rightbotOut() {
      this.rightbot = !this.rightbot;
    },
    getMInfo() {
      this.moduleIds.forEach(item => {
        let data = {
          module_id: 4,
          web_id: this.webID
        };
        getModuleInfo(data).then(res => {
          if (res.status_code == 1) {
            if (res.data.list.length > 0) {
              this.m4blogo = res.data.list[0];
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="less">
.homefooterad_main {
  position: relative;
  height: 100%;
  .homefooterad_top {
    height: 35px;
    text-align: center;
    line-height: 35px;
    color: white;
    background-color: #181a1a;

    //
    // margin: 0px -20px;
    // 282828
  }
  .homefooterad_bottom {
    background-color: #282828;
    position: absolute;
    top: 35px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    .homefooterad_bottom_main {
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      .footer_group {
        width: 100px;
      }
      .footer_group2 {
        .sns {
          color: #adadad;
          .snstop {
            margin-bottom: 15px;
            font-weight: bold;
            font-size: 13px;
          }
          .snsbot {
            position: relative;
            .snsbot1 {
              z-index: 99;
              display: flex;
              display: -webkit-flex;
              .snsitem {
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                padding: 5px 5px;
                height: 30px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  height: 100%;
                }
              }
              .snsitemhover {
                text-align: center;
                z-index: 99;
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                background-color: black;
                padding: 1px 1px;
                height: 140px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  width: 85%;
                }
              }
            }
            .snsbot2 {
              position: absolute;
              top: 50px;
              // z-index: 99;
              display: flex;
              display: -webkit-flex;
              .snsitem {
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                padding: 5px 5px;
                height: 30px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  height: 100%;
                }
              }
              .snsitemhover {
                text-align: center;
                z-index: 99;
                margin-right: 10px;
                width: 120px;
                border-radius: 10px;
                box-sizing: border-box;
                border: 1px solid white;
                background-color: black;
                padding: 1px 1px;
                height: 140px;
                .snsitemdesc {
                  height: 20px;
                  line-height: 20px;
                  float: left;
                  margin-right: 10px;
                }
                img {
                  width: 85%;
                }
              }
            }
          }
        }
      }
      .homefooterad_bottom_logo {
        width: 200px;
        img {
          // width: 80%;
          // height: 100%;
        }
      }
      position: absolute;
      bottom: 50px;
      left: 100px;
      top: 50px;
      right: 100px;
    }
    .homefooterad_bottom_copyrite {
      border-top: 1px solid #5d5d5d;
      // height: 90px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      right: 0px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      // margin: 0px -20px;
      color: #adadad;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/homeFooterAd.vue